import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    VStack,
    FormErrorMessage,
} from '@chakra-ui/react';
import { Field } from 'formik';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    formInputStyles,
} from 'components/forms/new/formStyles';
import NameField from '@/components/forms/new/formikFormFields/NameField';

const RuleTranslationField = ({ darkMode, errors, touched, ...props }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <FormControl
            isInvalid={!!errors.translation && touched.translation}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            isRequired>
            <Stack
                direction="row"
                sx={{ ...stackStyling(), ...formInputStyles }}>
                <Box w="200px">
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Translation
                    </FormLabel>
                </Box>
                <Box flex="1" minWidth="450px">
                    <VStack width="100%" alignItems="normal">
                        <Field
                            component={NameField}
                            id="translation"
                            name="translation"
                            placeholder="Enter translation"
                            validate={(value) =>
                                !value && 'Translation is required'
                            }
                            {...props}
                        />
                        <FormErrorMessage>
                            {errors.translation}
                        </FormErrorMessage>
                    </VStack>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Define the final output format of the dialed number. Use variables like $1 to represent the first capture group () from your Pattern. For example, a translation of +$1 replaces a matched '00' prefix with a standard E.164 '+'."
                        ariaLabel="rule translation tooltip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default RuleTranslationField;
